import styled from 'styled-components';

import {
    IconSuccess,
    spaceMixin,
    Text,
    token,
} from '@zillow/constellation';

import { baseFontStyle } from '../../StyledComponents';

export const StyledText = styled(Text)`
    && {
        ${baseFontStyle}
        margin-top: ${spaceMixin('xs')};
        text-align: center;
    }
`;

export const StyledSuccessIcon = styled(IconSuccess)`
    && {
        color: ${token('colors.green400')};
        margin: 0 auto ${spaceMixin('xs')};
        display: block;
    }
`;
